import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { getcategorymasters } from '../../utilities/api';

export const fetchCategoryMasters = createAsyncThunk('categoryMasters/fetch', async ({ rolename, clientname }, { rejectWithValue }) => {
    try {
        const data = await getcategorymasters({ rolename, clientname });
        return data;
    } catch (error) {
        return rejectWithValue(error.message || 'Failed to fetch category masters');
    }
});

const initialState = {
    clients: [],
    categoryData: [],
    selectedClient: null,
    loading: false,
    error: null
};

const categoryMastersSlice = createSlice({
    name: 'categoryMasters',
    initialState,
    reducers: {
        setSelectedClient: (state, action) => {
            state.selectedClient = action.payload;
        },
        resetFilters: (state) => {
            state.selectedClient = null;
            state.error = null;
        },
        clearError: (state) => {
            state.error = null;
        }
    },
    extraReducers: (builder) => {
        builder
            .addCase(fetchCategoryMasters.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(fetchCategoryMasters.fulfilled, (state, action) => {
                state.loading = false;
                const raw = action.payload || {};
                // Handle both flat { clients, category_masters } and nested { data: { ... } }
                const d = raw.data || raw;
                state.clients = Array.isArray(d.clients) ? d.clients : [];
                state.categoryData = Array.isArray(d.category_masters)
                    ? d.category_masters.map((item) => ({
                          ...item,
                          catmasters_status: item.catmasters_status || item.status || 'Active'
                      }))
                    : [];
            })
            .addCase(fetchCategoryMasters.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
                state.categoryData = [];
            });
    }
});

export const { setSelectedClient, resetFilters, clearError } = categoryMastersSlice.actions;

export const selectCategoryData = (state) => state.categoryMasters.categoryData;
export const selectClients = (state) => state.categoryMasters.clients;
export const selectLoading = (state) => state.categoryMasters.loading;
export const selectSelectedClient = (state) => state.categoryMasters.selectedClient;
export const selectError = (state) => state.categoryMasters.error;

export default categoryMastersSlice.reducer;
